<form>
    <div>
        <textarea class="input-field" placeholder="Notes" type="text" style="padding: 8px;" 
            [formControl]="notes" 
            (focusout)="setNotes()">
        </textarea>
    </div>
</form>